import Instance from '../../../utils/Axios';

// New Actions for the app

const GetTiposFaltas = () => async (dispatch) => {
  await Instance()
    .get(`/tipofaltas`)
    .then(({ data }) => {
      dispatch({ type: 'GET_TIPOFALTAS', payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetTiposFaltas;
